import {
  getUserAndDoctorInfo,
  getHistoryMsgs,
  loadOfflineMsgs,
  getUnreadInboxMsg,
  getWxRelation,
  uploadImEvent
} from './ImService.js'
import { ImRenderHandler } from './ImRenderHandler.js'
import { EventType } from './constants.js'
import { IMService, IMEventBus, AnimationRunner } from 'lib/mp-stjk-im-service'
import SystemUtil from '../lib/SystemUtil'
import { SendEventExecutor, SendEventTask } from "./SendEventExecutor"

import LibContext from 'config/Context';

wx.IMEventBus = IMEventBus

/**
 * 私人医生问诊上下文
 */
class ImContext {
  constructor(page, scene) {
    this.page = page
    this.scene = scene
    this.msgList = []
    this.doctorInfo = {}
    this.serviceLevel = null
    // 底部容器高度(根据底部呈现的不同组件会动态更新高度－》)
    // 机器人消息的高度和该字段无关
    this.footerContainerHeight = 0
    // im上下文
    this.simpleContext = null
    // 窗口高度
    this.windowHeight = page.data.windowHeight
    this.imRenderHandle = new ImRenderHandler()
    // 能否加载更多 避免多次触发
    this.isLoadMoreLocked = false
    this.imServiceInstance = new IMService({
      protocol: LibContext.getInstance().settings.PROTOCAL,
      resource: LibContext.getInstance().settings.RESOURCE,
      host: LibContext.getInstance().settings.SERVICE,
      port: LibContext.getInstance().settings.SERVICE_PORT,
      path: LibContext.getInstance().settings.SERVICE_PORT,
      jidHost: LibContext.getInstance().settings.JIDHOST,
      ticketInfo: `_tk=${LibContext.getInstance().tk}`,
    });
    this.sendEventExecutor = new SendEventExecutor()
  }
  /**
   * 设置用户和医生
   * @param res
   */
  readyToGetHistoryMsgs(userInfo, doctorInfo){
    this.userInfo = userInfo;
    this.doctorInfo = doctorInfo;
    return getHistoryMsgs(
      userInfo.userId,
      doctorInfo.doctorId,
      this.page.personId
    )
  }

  /**
   * 处理消息盒子中未读消息
   */
  handelUnreadInboxMsg(){
    const res = getUnreadInboxMsg(
      this.page.doctorId,
      this.page.personId
    );
    if (res.inboxMessage && res.inboxMessage.length) {
      IMEventBus.trigger('RENDER_INBOX_MSG', res.inboxMessage);
    }
  }

  /*建立im链接*/
  openConnection() {
    return new Promise((resolve) => {
      this.imServiceInstance.startMsgProcessing(
        this.doctorInfo.doctorId,
        Number(this.page.personId)
      );
      this.imServiceInstance.connect(this.userInfo.userId);
      IMEventBus.addListener('IM_CONNECTED', () => {
        resolve();
      });
    });
  }
  refreshImContext(
    eventType = EventType.REFRESH_IM,
    needCurrentNode = true,
    needScrollBottom = true
  ){
    // 切机时没必要关闭底部区域 解决首个节点为拍照节点时 拍照节点面板被销毁
    // if (needCurrentNode) {
    //   IMEventBus.trigger('CLOSE_RECONCILE');
    // }
    let that = this;
    const sendEventTask = new SendEventTask(
      this.page.doctorId,
      this.page.personId,
      // eventType,
      // this.page.plan,
      // this.page.gid
    );

    return this.sendEventExecutor
      .addTaskToExecuteQueue(sendEventTask).then((res) => {
        if (!res.result) {
          return;
        }
        const {
          commonInfo,
          renderInfo,
          requestCount,
          imDoctor,
          consultOrder,
          templateOrder
        } = res.result;

        if (requestCount != 1 && this._requestCount >= requestCount) {
          return;
        }
        that._requestCount = requestCount;
        that.simpleContext = res.result;
        // 当前的聊天医生
        this.doctorInfo.chatDoctorId = commonInfo.toId;
        // 处理renderInfo
        this.imRenderHandle.handleRenderInfo(
          commonInfo,
          renderInfo,
          imDoctor,
          this.doctorInfo.doctorId,
          this.page.gid,
          needScrollBottom
        );
        // 同意问诊 刷新上下文
        // if (manualInfo.autoConfirm) {
        //   agreeConsulting(commonInfo.bizId).then(() => {
        //     this.refreshImContext();
        //   });
        // }

        if(commonInfo&&commonInfo.interactiveMode==1&&templateOrder&&templateOrder.currentNode){
          IMEventBus.trigger("input_emitter", false);
          IMEventBus.trigger("robot_emitter", true, templateOrder);
          // this.triggerMsgRender(msg);
        }

        // 通知上下文更新
        IMEventBus.trigger('CONTEXT_CHANGE', res.result, {
          doctorId: this.doctorInfo.doctorId,
          personId: this.page.personId,
        }, needScrollBottom);
        return new Promise((resolve) => {
          resolve(res.result);
        });
      });
  };

  uploadImEventByDescription(){
    if(!this.page.illDescription)
      return
    
    let eventContent = {
      illDescription:decodeURIComponent(this.page.illDescription),
    }
    if(this.page.patientId){
      eventContent['patientId']=this.page.patientId
    }
    if(this.page.entrance){
      eventContent['consultEntrance']=this.page.entrance
    }
    let parament = {
      entranceDoctorId:this.page.doctorId,
      personId:this.page.personId,
      eventType:12,//进入家医IM发送主诉
      eventContent:JSON.stringify(eventContent)
    }
    uploadImEvent(parament)
  }

  initContext() {
    wx.showLoading({
      mask: true,
    });

    getUserAndDoctorInfo(this.page.doctorId)
      .then(({
        userInfo,
        doctorInfo
      }) => {
        return this.readyToGetHistoryMsgs(userInfo, doctorInfo);
      })
      .then((res) => {
        let msgList = (res.result && res.result.reverse()) || [];
        msgList.forEach((msg) => {
          msg.id = msg.id + ''
          msg.userInfo = this.userInfo;
          msg.doctorInfo = this.doctorInfo;
        });
        this.msgList.splice(0, 0, msgList);//delete ...
        this.page.setData({
          msgList: res.result,
        },
          () => {
            IMEventBus.trigger('REFRESH_SCROLLER');
          }
        );
        return this.openConnection();
      })
      .then((rs) => {
        this.uploadImEventByDescription()
        this.sendLastMsgReadAck();
        this.initContextEventListener();
        return this.refreshImContext(1);
      })
      .then((rs) => {
        wx.hideLoading();
        // 页面重新展示 需要刷新上下文
        this.page.onShow = () => {
          // 重新展示页面时，不需要关闭底部面板
          IMEventBus.trigger('REFRESH_CONTEXT', false, false);
          IMEventBus.trigger('LOAD_UNREAD_INBOX_MSG');
        };
      })
      .then(() => {
        this.handelUnreadInboxMsg();
      })
      .catch((ex) => {
        console.error(ex);
        wx.showToast({
          title: '服务异常，请稍后再试',
          icon: 'none',
          duration: 2000,
        });
      });

    // getPrivateDoctorDialogInfo(this.page.personId, this.page.doctorId)
    //   .then((res = {}) => {
    //     const {
    //       dialogMoudle = {}, serviceLevel
    //     } = res;
    //     const {
    //       subTitle = ''
    //     } = dialogMoudle;
    //     this.serviceLevel = serviceLevel;
    //     this.page.setData({
    //       subTitle,
    //       serviceLevel
    //     });
    //     this.refreshImContext()
    //   })

    getWxRelation(this.page.doctorId).then((res = {}) => {
      const { result, success } = res;
      if (success) {
        const { friend } = result || {};
        if (!friend) {
          if (result) {
            this.page.setData({
              wxRelation: result
            })
          }
        } else {
          this.page.setData({
            wxRelation: null
          })
        }
      }
    })
  }
  loadMoreHistoryMsgs() {
    if (this.isLoadMoreLocked) return;
    wx.createSelectorQuery()
      .select('.message-container')
      .boundingClientRect((result) => {
        const originHeight = result.height;
        const lastMsgId =
          this.msgList.length > 0 ? this.msgList[0].id : 0;
        // 加锁
        this.isLoadMoreLocked = true;
        getHistoryMsgs(
          this.userInfo.userId,
          this.doctorInfo.doctorId,
          this.page.personId,
          lastMsgId
        ).then((res) => {
          if (res.result && res.result.length) {
            let msgList = res.result.reverse() || [];
            msgList.forEach((msg) => {
              msg.userInfo = this.userInfo;
              msg.doctorInfo = this.doctorInfo;
            });
            this.msgList.splice(0, 0, msgList);//delete ...
            this.page.setData({
              msgList: res.result,
              scrollWithAnimation: false,
            },
              () => {
                this.isLoadMoreLocked = false;
                // 重新计算容器高度
                wx.createSelectorQuery()
                  .select('.message-container')
                  .boundingClientRect((r) => {
                    this.page.setData({
                      showLoading: false,
                      scrollTop: r.height - originHeight,
                    },
                      () => {
                        this.page.setData({
                          scrollWithAnimation: true,
                        });
                      }
                    );
                  })
                  .exec();
              }
            );
          } else {
            this.page.setData({
              noMoreData: '无更多数据',
              showLoading: false,
              noMoreDataFlag: true,
            });
          }
        });
      })
      .exec();
  }
  /**
   * 获取页头高度
   */
  getHeaderHeight(){
    return new Promise((reslove, reject) => {
      wx.createSelectorQuery()
        .in(this.page)
        .select('.header')
        .boundingClientRect((res) => {
          if (res && res.height) {
            reslove(res.height + res.top);
          }
        })
        .exec();
    });
  };
  /**
   * 重算容器高度
   * withSpecialFooter 如果是机器人输入框节点 或者底部控制面板 需要重新计算消息容器的高度
   */
  resetMsgContainerHeight(
    withSpecialFooter = false,
    needScrollBottom = true
  ) {
    this.getHeaderHeight().then((heightToMinus) => {
      let {
        commonInfo: {
          interactiveMode
        },
      } = this.simpleContext;
      const scrollHeight =
        this.windowHeight - heightToMinus - this.footerContainerHeight;
      this.page.setData({
        height: scrollHeight,
        interactiveMode,
      },
        () => {
          if (needScrollBottom) {
            IMEventBus.trigger('REFRESH_SCROLLER');
          }
        }
      );
    });
  }
  /**
   * 销毁im上下文
   */
  destoryImContext=()=> {
    // 标识实例已销毁
    this.imServiceInstance.hasDestory = true;
    // 清除监听器
    IMEventBus.clearImListener();
    // 关闭链接
    this.imServiceInstance.disconnect('close context');
    // 移除之前的事件监听器
    this.imServiceInstance.removeOnMessageListener();
    // 清除runner实例
    AnimationRunner.instance = null;
  }

  /**
   * 发送最后一条医生消息为已读消息
   */
  sendLastMsgReadAck() {
    const msgList = this.msgList.filter((msg) => {
      return (
        msg.fromId + '' !== this.userInfo.userId + '' &&
        msg.did + '' === this.page.doctorId + ''
      );
    });
    if (msgList.length > 0) {
      const msg = msgList[msgList.length - 1];
      if (typeof msg.feature === 'string') {
        msg.feature = JSON.parse(msg.feature);
      }
      
      console.log('send lastmsg readack', msg);
      this.imServiceInstance.sendReadAck(msg);
    }
  }


  isMsgAvaliable(msg){
    const filterList = this.msgList.filter((msgItem) => {
      if (msgItem.id + '' === msg.id + '') {
        return true;
      }
      return false;
    })
    return filterList.length === 0;
  }

  loadOfflineMsgList(){
    // 过滤微信消息和其它医生的消息
    let msgList = this.msgList.filter((msg) => {
      return ((msg.fromId !== this.userInfo.userId) || (msg.did === this.doctorInfo.doctorId)) && SystemUtil.filterWxMessage(msg)
    })

    const msgLength = msgList.length;
    let lastMsgId = '';
    if (msgLength > 0) {
      lastMsgId = msgList[msgLength - 1].id + '';
    }

    const offlineMsgs = loadOfflineMsgs(lastMsgId, this.page.personId);
    if (!offlineMsgs || !offlineMsgs.result) {
      return;
    }

    offlineMsgs.result.forEach((msg) => {
      msg.id = msg.id + '';
      // 处理离线消息
      if (
        this.isMsgAvaliable(msg) &&
        (msg.fromId === this.doctorInfo.doctorId ||
          msg.fromId === this.doctorInfo.chatDoctorId)
      ) {
        msg.isNew = true;
        msg.userInfo = this.userInfo;
        msg.doctorInfo = this.doctorInfo;
        if (typeof msg.feature === 'string') {
          msg.feature = JSON.parse(msg.feature);
        }
        // 发送readack消息
        this.imServiceInstance.sendReadAck(msg);
        this.msgList.push(msg);
        this.page.setData({
          msgNew: msg,
        },
          () => {
            // 刷新滚动条
            IMEventBus.trigger('REFRESH_SCROLLER');
          }
        );
      }
    });
    // 刷新上下文
    this.refreshImContext(EventType.REFRESH_IM, true);
  };

  /**
   * 初始化im事件监听
   */
  initContextEventListener() {
    IMEventBus.addListener('SEND_MESSGE', (data) => {
      const messageList = this.msgList;
      let feature;
      // 需要考虑已有发送feature的场景
      if (data.feature) {
        feature = JSON.parse(data.feature);
        // 设置档案人id
        feature['pid'] = this.page.personId;
      } else {
        feature = {
          pid: this.page.personId,
        };
      }
      // 返回当前这笔单子的聊天对象
      const { consultOrder, commonInfo } = this.simpleContext
      const { toId } = commonInfo || {};
      const { consultOrderId = 0 } = consultOrder || {};
      if (this.page.gid && this.page.gid != 'null' && this.page.gid != 'NULL') {
        feature['gid'] = this.page.gid || ''
      }

      feature['sdid'] = commonInfo.entranceDoctorId;
      feature['did'] = this.page.doctorId || this.doctorInfo.doctorId;
      feature['f1'] = this.userInfo.name
      feature['f2'] = this.userInfo.nick
      feature['f3'] = this.userInfo.imgUrl
      feature['scene'] = 2  // 企业微信私人医生消息需要同步到主客
      feature['cid'] = consultOrderId  // 问诊单ID
      if(this.page.diseaseDesc)
        feature['diseaseDesc'] = decodeURIComponent(this.page.diseaseDesc)

      if(this.page.patientId)
        feature['patientId'] = this.page.patientId

      if (this.page.entrance) {
        feature['ec'] = this.page.entrance // 页面来源
      }
      // 设置feature值
      data.feature = JSON.stringify(feature)

      // 消息发送
      const send = {
        fromId: this.userInfo.userId,
        toId: this.doctorInfo.chatDoctorId || this.doctorInfo.doctorId,
        did: this.page.doctorId,
        // ...data,//delete ...
      };

      const dataToSend = Object.assign({},send,data)
      this.imServiceInstance.sendMessage(dataToSend);
      // 默认发送均为
      dataToSend.isSendSuccess = false;
      dataToSend.userInfo = this.userInfo;
      dataToSend.doctorInfo = this.doctorInfo;
      messageList.push(dataToSend);
      this.page.setData({
        msgNew: dataToSend,
      }, () => {
        IMEventBus.trigger('REFRESH_SCROLLER');
      });
    });
    // 渲染消息
    IMEventBus.addListener('RENDER_MSG', (msg) => {
      let msgBody = msg.data.serialize();
      msgBody.isNew = true;
      msgBody.userInfo = this.userInfo;
      msgBody.doctorInfo = this.doctorInfo;
      this.page.setData({
        msgNew: msgBody,
      }, () => {
        IMEventBus.trigger('REFRESH_SCROLLER');
      });
      // 发送readack消息
      this.imServiceInstance.sendReadAck(msgBody);

      // 消息去重 理论上不会出现
      const hasRepeat = this.msgList.filter(v => {
        return v.id === msg.data.id
      }).length > 0;
      !hasRepeat && this.msgList.push(msgBody);
    });

    // 刷新上下文
    IMEventBus.addListener('REFRESH_CONTEXT', (needCurrentNode = true, needScrollBottom = true) => {
      this.refreshImContext(2, needCurrentNode, needScrollBottom);
    });

    // 重置底部容器高度 机器人输入框节点需要计算键盘高度
    IMEventBus.addListener(
      'RESET_FOOTER_CONTAINER_HEIGHT',
      (footerHeight, withSpecialFooter, keyboardHeight) => {
        // 如果是全面屏且键盘弹起 由于键盘已经包含了安全区域的高度 所以底部高度需要减去安全区高度
        if (
          keyboardHeight &&
          keyboardHeight > 0 &&
          SystemUtil.isIphoneFullScreen()
        ) {
          footerHeight =
            footerHeight - SystemUtil.BottomSaveAreaHeight;
        }
        this.footerContainerHeight = footerHeight;
        this.resetMsgContainerHeight(withSpecialFooter);
      }
    );

    // 刷新滚动条位置
    IMEventBus.addListener('REFRESH_SCROLLER', () => {
      this.page.setData({
        scrollTop: 100000,
      });
    });

    // 监听重算消息容器高度
    IMEventBus.addListener('CONTEXT_CHANGE', (context, pdInfo, needScrollBottom) => {
      this.resetMsgContainerHeight(false, needScrollBottom);
    });

    IMEventBus.addListener('RESET_CONTAINER_HEIGHT', () => {
      this.resetMsgContainerHeight(false, false);
    });

    // 消息发送反馈
    IMEventBus.addListener('SEND_MESSGE_ACK', (sid) => {
      let index = 0;
      while (this.msgList[index].id != sid) {
        index++;
      }
      this.msgList[index].isSendSuccess = true;
      this.page.setData({
        msgUpdate: this.msgList[index],
      });
    });
    // 消息重发
    IMEventBus.addListener('RE_SEND_MESSGE', (msg) => {
      // const { _netStatus, _page } = this._imInstance;
      // if (!_netStatus.isNetWork) {
      //   _page.toast.toastText({text: '当前网络异常，请稍后再试!'});
      //   return;
      // }
      this.imServiceInstance.sendMessage(msg);
    });
    // im互踢
    IMEventBus.addListener('IM_CONFLICT', (doctorId) => {
      const that = this;
      wx.showToast({
        title: '问诊冲突，请退出重试',
        icon: 'none',
        duration: 3000,
        success: function () {
          that.destoryImContext();
          setTimeout(() => {
            wx.navigateBack({
              delta: 1,
            });
          }, 3000);
        },
      });
    });
    // im重连成功 需获取离线消息 并 刷新上下文
    IMEventBus.addListener('IM_RECONNECTED', this.loadOfflineMsgList);
    IMEventBus.addListener('IM_CONNECTED', this.loadOfflineMsgList);

    // 获取消息盒子中未读消息
    IMEventBus.addListener(
      'LOAD_UNREAD_INBOX_MSG',
      this.handelUnreadInboxMsg
    );

    // 续费
    IMEventBus.addListener('INVALID_ACCOUNT_RENEW', (objs) => {
      console.log("INVALID_ACCOUNT_RENEW", objs);
      let extendInfoJson = objs.extendInfo;
      let extendInfo = {};
      try {
        if (extendInfoJson) {
          extendInfo = JSON.parse(extendInfoJson);
          if (extendInfo && extendInfo.renewDisplayInfo) {
            extendInfo.renewDisplayInfo = JSON.parse(extendInfo.renewDisplayInfo);
          }
        }
      } catch (error) {
        console.log('组件的属性列表:', error);
        extendInfo = {};
      }

      const tipText = extendInfo && extendInfo.renewDisplayInfo ? extendInfo.renewDisplayInfo.tipText : '';
      this.page.setData({
        jumpUrl: extendInfo && extendInfo.renewDisplayInfo ? extendInfo.renewDisplayInfo.jumpUrl : '',
        tipText,
        clickText: extendInfo && extendInfo.renewDisplayInfo ? extendInfo.renewDisplayInfo.clickText : '',
      });
    });

    // 跳转医生主页
    IMEventBus.addListener("GO_TO_PRIVATE_DOCTOR_PAGE", () => {
      const { consultantInfo } = this.simpleContext;
      if (consultantInfo) {
        const { isFamilyDoctor, active } = consultantInfo;
        if (isFamilyDoctor && active) {
          const url = `/subpackages/familyDoctor/index?doctorId=&doctorId=${this.page.doctorId}`;
          wx.navigateTo({ url });
        }  
      }
    });

    // 跳转续费页
    IMEventBus.addListener("GO_TO_RENEW_PAGE", () => {
      this.page.goToPayWebPage();
    });

    // 监听绑定卡片点击展示弹框
    IMEventBus.addListener("show-bind-info-remind", (option, index) => {
      const { remindData, isDialogOpen } = option;
      this.page.setData({
          remindData,
          isDialogOpen
      });
  });
  }
}
export default ImContext;